import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import style from './register.module.css'
import girl1 from '../../img/girl1.png'
import girl2 from '../../img/girl2.png'
import girl3 from '../../img/girl3.png'
import girl4 from '../../img/girl4.png'
import girl5 from '../../img/girl5.png'
import girl6 from '../../img/girl6.png'
import girl7 from '../../img/girl7.png'
import Search from '../../modules/city/city';
import UploadPhotoBig from '../../img/no_photo.png'
import UploadPhotoMin from '../../img/add_photo.png'
import { useAuthLocalStorage } from '../../modules/useLocalStore';
import Popup from '../../modules/popup/popup';

function Register({stage , setStage , myProfile , setMyProfile}){

    const profile = [
        {id: 0, top: 'Марина 23 года', photo: girl1, hobbyone: 'Прогулки', hobbytwo: 'Танцы', hobbycount: '+5'},
        {id: 1, top: 'Полина 20 лет', photo: girl2, hobbyone: 'Кино', hobbytwo: 'Игры', hobbycount: '+4'},
        {id: 2, top: 'Дарья 28 лет', photo: girl3, hobbyone: 'Походы', hobbytwo: 'Кино', hobbycount: '+7', geo: 'от Вас 5 км'},
        {id: 3, top: 'Лера 26 лет', photo: girl4, hobbyone: 'Спорт', hobbytwo: 'Ужасы', hobbycount: '+3', geo: 'от Вас 1.5 км'},
        {id: 4, top: 'Василина 25 лет', photo: girl5, hobbyone: 'Спорт', hobbytwo: 'Юмор', hobbycount: '+7', geo: 'от Вас 3.5 км'},
        {id: 5, top: 'Рита 28 лет', photo: girl6, hobbyone: 'Кино', hobbytwo: 'Прогулки', hobbycount: '+2', geo: 'от Вас 4 км'},
        {id: 6, top: 'Юля 25 лет', photo: girl7, hobbyone: 'Кофе', hobbytwo: 'Прогулки', hobbycount: '+6', geo: 'от Вас 7 км'}
    ];
    const { saveToken } = useAuthLocalStorage();
    const [ReStage,SetReStage] = useState(0);
    const [metaDate,SetMetaDate] = useState(
        {
            sex: 0,
            city: '',
            name: '',
            day: '',
            month: '',
            year: '',
            target: '',
            login: '',
            password: '',
            utm: ''
        }
    );
    const days = Array.from({ length: 31 }, (_, i) => i + 1);
    const months = [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ];
    const years = Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i);
    
    const [day, setDay] = useState('01');
    const [month, setMonth] = useState('Январь');
    const [year, setYear] = useState('2000');
    const [cityz,setCity] = useState('');
    const [name,setName] = useState('');
    const [login,setLogin] = useState('');
    const [pass,setPass] = useState('');
    const [tok,setTimeToken] = useState(null);
    const handleLoginChange = (e) => {
        setLogin(e.target.value);
    };
    const handlePassChange = (e) => {
        setPass(e.target.value);
    };
    const handleDayChange = (e) => {
        setDay(e.target.value);
    };
    const handleNameChange = (e) => {
        setName(e.target.value);
    };

    const handleMonthChange = (e) => {
        setMonth(e.target.value);
    };

    const handleYearChange = (e) => {
        setYear(e.target.value);
    };
    const exitPopup = () => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: null
            }
        }));
    }
    const PopupOpen = (ind) => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: ind
            }
        }));
    };
useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const utm = queryParams.get('utm_source');
    
    if (utm) {
      // Сохраняем utm_source в состоянии
      SetMetaDate(prevState => ({...prevState, utm: utm}));
      
      // Удаляем utm_source из URL-параметров
      queryParams.delete('utm_source');
      
      // Обновляем URL без параметра utm_source
      window.history.replaceState(null, '', window.location.pathname + '?' + queryParams.toString());
    }
    else
    {
        SetMetaDate(prevState => ({...prevState, utm: 'none'}));
    }
  }, []); 
    function SetDate(meta, value)
    {
        switch(ReStage) {
            case 0:
                const urlz = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/checkip`;
                axios.post(urlz)
                .then(response => {
                    if(!response.data.login) {
                        PopupOpen(27);
                        return false;
                    } else {
                        SetMetaDate(prevState => ({...prevState, [meta]: value}));
                        SetReStage(prevState => prevState + 1);
                    }
                });
                break;
            case 1:
                if(value.length < 2)
                    return alert('Выберите город из списка');

                SetMetaDate(prevState => ({...prevState, [meta]: value}));
                SetReStage(prevState => prevState + 1);
                break;
            case 2:
                if(value.length < 2)
                    return alert('Заполните имя');
                
                SetMetaDate(prevState => ({...prevState, [meta]: value}));
                SetReStage(prevState => prevState + 1);
                break;
            case 3:
                if(year > 2007)
                    return alert('Вы не проходите по возрастному ограничению');

                SetMetaDate(prevState => ({...prevState, day: day , month: month, year: year}));
                SetReStage(prevState => prevState + 1);
                break;
            case 4:
                SetMetaDate(prevState => ({...prevState, [meta]: value}));
                SetReStage(prevState => prevState + 1);
                break;
            case 5:
                if(value.length < 5)
                    return alert('Заполните логин');

                    const date = { "login" : value };
                    const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/checklogin`;
                    axios.post(url,  date )
                    .then(response => {
                       
                    if(!response.data.login) {
                        alert('Логин занят используйте другой');
                        return false;
                    } else {
                        SetMetaDate(prevState => ({...prevState, [meta]: value}));
                        SetReStage(prevState => prevState + 1);
                    }
                   
                })
                    .catch(error => {
                        console.error(error);
                });
                
                break;
            case 6:
                if(value.length < 6)
                    return alert('Заполните пароль (минимум 6 символов)');

                SetMetaDate(prevState => ({...prevState, [meta]: value}));
                SetReStage(prevState => prevState + 1);
                break;
            default:
                break;

        }
        
    }
    useEffect(() => {
    
            if(ReStage === 7)
            {
                const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/register`;
                

                axios.post(url,  metaDate)
                .then(response => {
                    saveToken(response.data.token);
                    setStage(1);
                })
                    .catch(error => {
                        console.error(error);
                });
                
            }
           
            
        }, [metaDate,ReStage]);
    
    return(
        <div className={style.flexblock}>
            
            {    
                (() =>{switch (ReStage) {
                        case 0:
                            return (
                                <>
                                <div className={style.leftcontent}>
                                <h1>Создание аккаунта</h1>
                                <div className={style.oblako}>
                                    <div className={style.flexoblakotop}>
                                        <h4>Расскажи о себе</h4>
                                        <h2>🫶</h2>
                                    </div>
                                    <p>Это поможет создать профиль и сразу начать общаться.</p>
                                    <button className={`${style.btngred} ${style.btnwo}`} onClick={() => {
                                       SetDate('sex',0);
                                    }}>Я мужчина</button>
                                    <button className={`${style.btngred} ${style.mb75}`} onClick={() => {
                                         SetDate('sex',1);
                                    }}>Я женщина</button>
                                </div>
                                </div>
                                </>
                            );
                        case 1:
                            return (
                                <>
                                <div className={style.leftcontent}>
                                <h1>Создание аккаунта</h1>
                                <div className={style.oblako}>
                                    <div className={style.flexoblakotop}>
                                        <h4>Выбери город</h4>
                                        <h2>👌</h2>
                                    </div>
                                    <p className={style.mb33}>Выбери свое место положение из списка.</p>
                                    <Search customStyle={style.inputb} selected={cityz} setCityChange={setCity}/>
                                    <button className={`${style.btngred} ${style.mb75}`} onClick={() => {
                                        SetDate('city', cityz);
                                    }}>Далее</button>
                                </div>
                                </div>
                                </>
                            );
                        case 2:
                            return (
                                <>
                                <div className={style.leftcontent}>
                                <h1>Создание аккаунта</h1>
                                <div className={style.oblako}>
                                    <div className={style.flexoblakotop}>
                                        <h4>Как тебя Зовут?</h4>
                                        <h2>👈</h2>
                                    </div>
                                    <p className={style.mb33}>Укажи свое имя и мы продолжим.</p>
                                    <input className={style.inputb} onChange={handleNameChange} value={name} placeholder='Твое имя' />
                                    <button className={`${style.btngred} ${style.mb75}`} onClick={() => {
                                         SetDate('name', name);
                                    }}>Далее</button>
                                </div>
                                </div>
                                </>
                            );
                        case 3:
                                return (
                                    <>
                                    <div className={style.leftcontent}>
                                    <h1>Создание аккаунта</h1>
                                    <div className={style.oblako}>
                                        <h3>Выбери дату рождения</h3>
                                        <p className={style.mb33}>Укажи свою дату рождения:</p>
                                        <div className={style.dateinput}>
                                            <select value={day} onChange={handleDayChange}>
                                                
                                                {days.map(d => <option key={d} value={d}>{d}</option>)}
                                            </select>
                                            <select value={month} onChange={handleMonthChange}>
                                                
                                                {months.map(m => <option key={m} value={m}>{m}</option>)}
                                            </select>
                                            <select value={year} onChange={handleYearChange}>
                                                
                                                {years.map(y => <option key={y} value={y}>{y}</option>)}
                                            </select>
                                        </div>
                                        <button className={`${style.btngred} ${style.mb75}`} onClick={() => {
                                           SetDate('unset', 0);
                                        }}>Далее</button>
                                    </div>
                                    </div>
                                    </>
                                );
                            case 4:
                                    return (
                                        <>
                                        <div className={style.leftcontent}>
                                        <h1>Создание аккаунта</h1>
                                        <div className={style.oblako}>
                                            <h3>Выбери цель знакомства</h3>
                                            <p className={style.mb33}>Выбери подходящее:</p>
                                            <button className={`${style.btntarget}`} onClick={() => {
                                                SetDate('target', 'Без обязательств');
                                            }}>Без обязательств</button>
                                             <button className={`${style.btntarget}`} onClick={() => {
                                                SetDate('target', 'Серьезные отношения');
                                            }}>Серьезные отношения</button>
                                            <button className={`${style.btntarget}`} onClick={() => {
                                                SetDate('target', 'Дружеское общение');
                                            }}>Дружеское общение</button>
                                            <button className={`${style.btntarget} ${style.mb34}`} onClick={() => {
                                                SetDate('target', 'Флирт и свидание');
                                            }}>Флирт и свидание</button>
                                        </div>
                                        </div>
                                        </>
                                    );
                        case 5:
                            return (
                                <>
                                <div className={style.leftcontent}>
                                <h1>Создание аккаунта</h1>
                                <div className={style.oblako}>
                                    <div className={style.flexoblakotop}>
                                        <h4>Заполни логин</h4>
                                        <h2>✌️</h2>
                                    </div>
                                    <p className={style.mb33}>Электронная почта или номер телефона.</p>
                                    <input className={style.inputb} placeholder='Email или номер телефона' name='login' value={login} onChange={handleLoginChange} />
                                    <button className={`${style.btngred} ${style.mb75}`} onClick={() => {
                                        SetDate('login', login);
                                    }}>Далее</button>
                                </div>
                                </div>
                                </>
                            );
                        case 6:
                            return (
                                <>
                                <div className={style.leftcontent}>
                                <h1>Создание аккаунта</h1>
                                <div className={style.oblako}>
                                    <div className={style.flexoblakotop}>
                                        <h4>Придумай пароль</h4>
                                        <h2>💪</h2>
                                    </div>
                                    <p className={style.mb33}>Придумай надежный пароль для своей учетной записи.</p>
                                    <input className={style.inputb} placeholder='Пароль' name='pass' value={pass} onChange={handlePassChange}/>
                                    <button className={`${style.btngred} ${style.mb75}`} onClick={() => {
                                       SetDate('password', pass);
                                    }}>Далее</button>
                                </div>
                                </div>
                                </>
                            );
                         
                        default:
                            return null;
                        }
                })()
            }
            
            {profile[ReStage] && 
                <div className={style.rightcard} style={{ backgroundImage: `url(${profile[ReStage].photo})` }}>
                    <div className={style.flexcard}>
                        <div className={style.flextop}>
                            <div className={style.namecard}>
                                {profile[ReStage].top}
                            </div>
                            <div className={style.geocard}>
                                {profile[ReStage].geo ? profile[ReStage].geo : null}
                            </div>
                        </div>
                        <div className={style.bottomcard}>
                            <div className={style.cardwhite}>
                                {profile[ReStage].hobbyone}
                            </div>
                            <div className={style.cardwhite}>
                                {profile[ReStage].hobbytwo}
                            </div>
                            <div className={style.cardtrans}>
                                {profile[ReStage].hobbycount}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
     );
}

export default Register;